module.exports = __webpack_public_path__ + "img/img2.76d5f108.jpeg";